import { __rest } from "tslib";
import sortedIndexBy from 'lodash/sortedIndexBy';
import { cuid } from '@/utils';
import { MAX_COUNT_OF_PRODUCTS, MIN_COUNT_OF_PRODUCTS } from './pinned-products.constants';
export const addId = (list) => list.map((item) => (Object.assign(Object.assign({}, item), { id: cuid() })));
export const removeId = (list) => list.map((_a) => {
    var { id: _id } = _a, item = __rest(_a, ["id"]);
    return (item);
});
const insertIntoList = (list, item, conflictAdjustment) => {
    const insertionIndex = sortedIndexBy(list, item, (i) => Number(i.position) * conflictAdjustment);
    list.splice(insertionIndex, 0, item);
    // Adjust conflicting positions so the list stays strictly ordered after insertion.
    return list.reduce((acc, current) => {
        var _a;
        acc.push(((_a = acc[acc.length - 1]) === null || _a === void 0 ? void 0 : _a.position) === current.position && current.position !== ''
            ? Object.assign(Object.assign({}, current), { position: Number(current.position) + conflictAdjustment }) : current);
        return acc;
    }, []);
};
export const changeElementPosition = (list, item, newPosition) => {
    const adjustedItem = Object.assign(Object.assign({}, item), { position: newPosition });
    if (list.length === 1) {
        return [adjustedItem];
    }
    const listWithoutItem = list.filter(({ id }) => id !== item.id);
    if (item.position === '') {
        if (newPosition === MIN_COUNT_OF_PRODUCTS) {
            return insertIntoList(listWithoutItem, adjustedItem, 1);
        }
        if (newPosition === MAX_COUNT_OF_PRODUCTS) {
            return insertIntoList(listWithoutItem.reverse(), adjustedItem, -1).reverse();
        }
    }
    return newPosition < item.position || item.position === ''
        ? insertIntoList(listWithoutItem, adjustedItem, 1)
        : insertIntoList(listWithoutItem.reverse(), adjustedItem, -1).reverse();
};
export const getSortedByPosition = (list) => ([...list].sort((a, b) => {
    // Numbers come before strings, and numeric positions sort ascending.
    if (typeof a.position === 'number' && typeof b.position === 'number') {
        return a.position - b.position;
    }
    if (typeof a.position === 'number') {
        return -1;
    }
    if (typeof b.position === 'number') {
        return 1;
    }
    // Maintain the relative order of string positions.
    return 0;
}));
export const getNewProductItemPosition = (list) => {
    if (list.length === 0) {
        return 1;
    }
    const sortedPositions = getSortedByPosition(list).map(({ position }) => Number(position));
    const isLastPositionFilled = list.some(({ position }) => position === MAX_COUNT_OF_PRODUCTS);
    if (isLastPositionFilled) {
        sortedPositions.reverse();
        for (let i = 0; i < sortedPositions.length - 1; i++) {
            const current = sortedPositions[i];
            const next = sortedPositions[i + 1];
            if (current - next > 1) {
                return current - 1;
            }
        }
    }
    return sortedPositions[sortedPositions.length - 1] + 1;
};
